export const uppercase = `
  text-transform: uppercase;
  letter-spacing: 0.02em;
`;

// increasing font scale
// DEPRECATED: use the css custom properties from now on
// in components/App/index.scss
// e.g. font-size: var(--fontScale1);
export const fontScale1 = 'calc(var(--baseFontSize) * var(--fontMultiplier))';
export const fontScale2 =
  'calc((var(--baseFontSize) * var(--fontMultiplier)) * var(--fontMultiplier))';
export const fontScale3 =
  'calc(((var(--baseFontSize) * var(--fontMultiplier)) * var(--fontMultiplier)) * var(--fontMultiplier))';
export const fontScale4 =
  'calc((((var(--baseFontSize) * var(--fontMultiplier)) * var(--fontMultiplier)) * var(--fontMultiplier)) * var(--fontMultiplier))';
export const fontScale5 =
  'calc(((((var(--baseFontSize) * var(--fontMultiplier)) * var(--fontMultiplier)) * var(--fontMultiplier)) * var(--fontMultiplier)) * var(--fontMultiplier))';

// decreasing font font scale
export const fontScaleNeg1 =
  'calc(var(--baseFontSize) / var(--fontMultiplier))';
export const fontScaleNeg2 =
  'calc((var(--baseFontSize) / var(--fontMultiplier)) / var(--fontMultiplier))';
export const fontScaleNeg3 =
  'calc(((var(--baseFontSize) / var(--fontMultiplier)) / var(--fontMultiplier)) / var(--fontMultiplier))';
export const fontScaleNeg4 =
  'calc((((var(--baseFontSize) * var(--fontMultiplier)) / var(--fontMultiplier)) / var(--fontMultiplier)) * var(--fontMultiplier))';
export const fontScaleNeg5 =
  'calc(((((var(--baseFontSize) * var(--fontMultiplier)) / var(--fontMultiplier)) / var(--fontMultiplier)) / var(--fontMultiplier)) / var(--fontMultiplier))';

export default {
  fontScale1,
  fontScale2,
  fontScale3,
  fontScale4,
  fontScale5,
  fontScaleNeg1,
  fontScaleNeg2,
  fontScaleNeg3,
  fontScaleNeg4,
  fontScaleNeg5,
  uppercase
};
